// Spanish texts for src/components/site (23 Oct 2026). Keys are the English texts.
export const SITE: Record<string, string> = {
  "Analyses on {date}": "Análisis del {date}",
  "Today's analyses": "Análisis de hoy",
  "View alerts →": "Ver alertas →",
  "No analyses yet": "Aún no hay análisis",
  "batch": "lote",
  "No change": "Sin cambios",
  "high activity": "mucha actividad",
  "activity detected": "actividad detectada",
  "site idle — events captured but no change": "obra sin actividad: hay capturas pero sin cambios",
  "idle": "sin actividad",
  "no events captured in this window": "sin capturas en este periodo",
  "no data": "sin datos",
  "Cameras on {date}": "Cámaras el {date}",
  "Cameras": "Cámaras",
  "No camera configured for this project.": "No hay ninguna cámara configurada en este proyecto.",
  "Camera": "Cámara",
  "Choose camera": "Elegir cámara",
  "Previous camera": "Cámara anterior",
  "Next camera": "Cámara siguiente",
  "{name} snapshot": "Foto de {name}",
  "Adjust framing for {name}": "Ajustar encuadre de {name}",
  "Adjust framing": "Ajustar encuadre",
  "online": "conectada",
  "offline": "desconectada",
  "Online": "Conectada",
  "Offline": "Desconectada",
  "Photo checked by Zonoo at {time}": "Foto revisada por Zonoo a las {time}",
  "Last image {time}": "Última imagen {time}",
  "See live photo ({time})": "Ver foto en directo ({time})",
  "Back to checked photo": "Volver a la foto revisada",
  "Camera view has moved since {time}. Site updates may show less until it is pointed back.": "La vista de la cámara se ha movido desde {time}. Los resúmenes de obra pueden mostrar menos hasta que se vuelva a orientar.",
  "dashboard thumbnail": "miniatura del panel",
  "Previous day": "Día anterior",
  "Pick date": "Elegir fecha",
  "Next day": "Día siguiente",
  "Today": "Hoy",
  "Upload failed. Please try again.": "No se pudo subir. Inténtalo de nuevo.",
  "Couldn't generate the timeline. Please try again.": "No se pudo generar el cronograma. Inténtalo de nuevo.",
  "Project documents": "Documentos del proyecto",
  "Choose a file to upload": "Elige un archivo para subir",
  "Choose file": "Elegir archivo",
  "No file selected yet": "Ningún archivo seleccionado",
  "Generating…": "Generando…",
  "Generated": "Generado",
  "Generate timeline": "Generar cronograma",
  "Uploading “{name}”…": "Subiendo «{name}»…",
  "“{name}” uploaded.": "«{name}» subido.",
  "Couldn’t upload “{name}”: {message} Please try again.": "No se pudo subir «{name}»: {message} Inténtalo de nuevo.",
  "Draft schedule ready for review — opening the Project schedule card now. It won’t take effect until accepted.": "Borrador de planificación listo para revisar: se abre ahora la tarjeta de Planificación del proyecto. No se aplicará hasta que lo aceptes.",
  "Delete": "Eliminar",
  "Today's captures": "Capturas de hoy",
  "No captures yet": "Aún no hay capturas",
  "1 capture": "1 captura",
  "{n} captures": "{n} capturas",
  "Plan uploaded. Now click \"Let Lia read it\".": "Plano subido. Ahora pulsa «Que Lia lo lea».",
  "Lia is taking too long. Try again in a minute.": "Lia está tardando demasiado. Inténtalo de nuevo en un minuto.",
  "Lia read the plan. Check the drawing and the text below, correct anything, then Confirm.": "Lia ha leído el plano. Revisa el dibujo y el texto de abajo, corrige lo que haga falta y pulsa Confirmar.",
  "Confirmed. From the next photo check, Zonoo uses these names.": "Confirmado. A partir de la próxima revisión de fotos, Zonoo usará estos nombres.",
  "Floor plan (admins)": "Plano (administradores)",
  "Floor plan (Lia)": "Plano (Lia)",
  "Upload the floor plan with the cameras marked on it. Lia reads the rooms and what each camera sees; after you confirm, the photo checks use the plan's names for places.": "Sube el plano con las cámaras marcadas. Lia lee las estancias y lo que ve cada cámara; cuando confirmes, las revisiones de fotos usarán los nombres del plano.",
  "(open)": "(abrir)",
  "Floor plan": "Plano",
  "Choose the floor plan": "Elegir el plano",
  "Uploading…": "Subiendo…",
  "Replace plan": "Sustituir plano",
  "Upload plan": "Subir plano",
  "Lia is reading… (about a minute)": "Lia está leyendo… (aprox. un minuto)",
  "Read it again": "Volver a leer",
  "Let Lia read it": "Que Lia lo lea",
  "Lia is reading your plan… this takes 1–2 minutes. You can keep the panel open.": "Lia está leyendo tu plano… tarda 1–2 minutos. Puedes dejar el panel abierto.",
  "Something wrong in her drawing? Tell Lia, then click \"Read it again\"": "¿Algo mal en su dibujo? Díselo a Lia y pulsa «Volver a leer»",
  "e.g. the sleeping area is part of the living room; the strip next to the bedroom is a closet": "p. ej. la zona de dormir forma parte del salón; la franja junto al dormitorio es un armario",
  "How Lia drew your plan (check rooms and cameras)": "Cómo ha dibujado Lia tu plano (revisa estancias y cámaras)",
  "Lia's drawing of the floor plan": "Dibujo del plano hecho por Lia",
  "What Lia read: edit names, or delete a room from the Rooms line to remove it from the drawing": "Lo que ha leído Lia: edita los nombres o borra una estancia de la línea Rooms para quitarla del dibujo",
  "Saving…": "Guardando…",
  "Confirm": "Confirmar",
  "In use since {time}": "En uso desde {time}",
  " · a new reading is waiting for your Confirm": " · hay una nueva lectura pendiente de tu confirmación",
  "Not in use until you confirm.": "No se usa hasta que confirmes.",
  "Edges online": "Equipos de obra conectados",
  "Cameras online": "Cámaras conectadas",
  "Captures today": "Capturas de hoy",
  "Pending alerts": "Alertas pendientes",
  "Last analysis": "Último análisis",
  "Needs attention ({count})": "Requiere atención ({count})",
  "No issues flagged in the latest observations.": "No se ha detectado ningún problema en las últimas observaciones.",
  "No recent camera observations are available to check yet.": "Todavía no hay observaciones recientes de las cámaras para revisar.",
  "attention": "atención",
  "Suggested action:": "Acción sugerida:",
  "Dismissing…": "Descartando…",
  "Dismiss": "Descartar",
  "{n} observations": "{n} observaciones",
  "Marking reviewed…": "Marcando como revisado…",
  "Mark reviewed": "Marcar como revisado",
  "That action failed. Please try again.": "No se pudo completar la acción. Inténtalo de nuevo.",
  "Project schedule": "Planificación del proyecto",
  "Currently accepted schedule: 1 phase, accepted {when}.": "Planificación aceptada: 1 fase, aceptada {when}.",
  "previously": "anteriormente",
  "Currently accepted schedule: {n} phases, accepted {when}.": "Planificación aceptada: {n} fases, aceptada {when}.",
  "No schedule has been accepted yet -- the Site Update planning note and the phase timeline stay purely observational until one is.": "Todavía no se ha aceptado ninguna planificación: la nota de planificación del resumen de obra y el cronograma de fases solo reflejan lo observado hasta que se acepte una.",
  "Draft awaiting review": "Borrador pendiente de revisión",
  "Review draft": "Revisar borrador",
  "Review schedule": "Revisar planificación",
  "Project schedule review": "Revisión de la planificación del proyecto",
  "Editing starts a new draft from the accepted schedule -- the accepted one stays in effect until you accept the edited version.": "Al editar se crea un nuevo borrador a partir de la planificación aceptada; la aceptada sigue vigente hasta que aceptes la versión editada.",
  "Edit schedule": "Editar planificación",
  "Nothing to review right now. Generate a new timeline from a document above to create a draft.": "No hay nada que revisar ahora. Genera un nuevo cronograma a partir de un documento de arriba para crear un borrador.",
  "Draft awaiting review -- not yet in effect": "Borrador pendiente de revisión: aún no está vigente",
  "Project brief": "Descripción del proyecto",
  "Phase name": "Nombre de la fase",
  "Planned start": "Inicio previsto",
  "Planned end": "Fin previsto",
  "Expected activity": "Actividad prevista",
  "Save changes": "Guardar cambios",
  "Accept schedule": "Aceptar planificación",
  "Discard draft": "Descartar borrador",
  "Open →": "Abrir →",
  "Your site team": "Tu equipo de obra",
  "← Projects": "← Proyectos",
  "Site setup, {n} need attention": "Configuración de la obra, {n} requieren atención",
  "Site setup": "Configuración de la obra",
  "Active": "Activa",
  "Paused": "En pausa",
  "admins only": "solo administradores",
  "Needs attention": "Requiere atención",
  "Camera framing": "Encuadre de las cámaras",
  "No camera configured.": "No hay ninguna cámara configurada.",
  "Other updates ({n})": "Otras novedades ({n})",
  "Marking…": "Marcando…",
  "Mark read": "Marcar como leído",
  "See full history →": "Ver todo el historial →",
  "Site update": "Resumen de obra",
  "Site update period": "Periodo del resumen de obra",
  "This week": "Esta semana",
  "Latest observation:": "Última observación:",
  "Next check:": "Próxima revisión:",
  "Planning note": "Nota de planificación",
  "Loading…": "Cargando…",
  "View evidence": "Ver pruebas",
  "Daily Brief": "Resumen diario",
  "Report updated {time}": "Informe actualizado {time}",
  "Suggested action": "Acción sugerida",
  "Weekly Summary": "Resumen semanal",
  "Project timeline": "Cronograma del proyecto",
  "Swipe the chart sideways to see the whole project →": "Desliza el gráfico hacia los lados para ver todo el proyecto →",
  "Planned": "Prevista",
  "In progress": "En curso",
  "Done": "Terminada",
  "Actual": "Real",
  "Claude has been suggesting closing this phase for {n} days": "Claude lleva {n} días sugiriendo cerrar esta fase",
  "Closing…": "Cerrando…",
  "Close ({n}d)": "Cerrar ({n} d)",
  "Planned:": "Previsto:",
  "Actual:": "Real:",
  "ongoing": "en curso",
}
